<template>
  <div class="ui-menu-content__list-item-container not-found">
    <ui-icon size="13" :color="$colors.gray40" icon="fa fa-search-minus" />
    <span class="ui-menu-content__list-item-text ml-2">{{ t('Not found') }}</span>
  </div>
</template>

<script setup lang="ts">
import { useColors, useI18n } from '@/composables';

const { t } = useI18n();
const $colors = useColors();
</script>

<style lang="scss" scoped>
.not-found {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
